export default __webpack_public_path__ + "static/media/tree1.5c1d5544.png";